import { Navigate } from  "react-router-dom";
import BasicLayout from "../components/Layout/Layout";

const PrivateRoute : React.FC<{Component: React.FC }> = (props) => {
  const condition = localStorage.getItem('token');
  return condition ? (<BasicLayout><props.Component /></BasicLayout>) :  (<Navigate  to="/login"  />);

}

export default PrivateRoute